import React, { useEffect } from 'react'
import { Sidebar, BreadCrumb } from '.'
import { useLocation } from 'react-router-dom';

import * as routeNames from "../../routes/routeName";


export const AppLayout = ({ children, activeTab }) => {

    const location = useLocation()
    const allRoutes = [
        routeNames.pharmacy_task_management,
        routeNames.pharmacy_inventory_list,
        routeNames.pharmacy_inventory_accountability,
        routeNames.pharmacy_fridge_temperature_log,
        routeNames.pharmacy_total_reversed,
        routeNames.pharmacy_speciality_medication_packs,
        routeNames.pharmacy_speciality_pack,
        routeNames.pharmacy_dailymedication_packs,
        routeNames.pharmacy_patient_vials_pack,
        routeNames.pharmacy_dailyvials_packs,
        routeNames.pharmacy_vials_packs,
        routeNames.pharmacy_blister_patients,
        routeNames.pharmacy_blister_daily_packs,
        routeNames.pharmacy_blister_packs,
        routeNames.pharmacy_blister_pack_on_shelf,
        routeNames.pharmacy_blister_sheets_report,
        routeNames.pharmacy_blister_sheets,
        routeNames.pharmacy_accountability_prep_check,
        routeNames.pharmacy_accountability_pickup_log,
        routeNames.pharmacy_accountability_final_check,
        routeNames.pharmacy_accountability_today_missed_rx,
        routeNames.pharmacy_accountability_all_reports,
        routeNames.pharmacy_accountability_new_rx,

        routeNames.pharmacy_blister_packaging_processing,
        routeNames.pharmacy_blister_packaging_prn_processing,
        routeNames.pharmacy_blister_packaging_liquid_processing,
        routeNames.pharmacy_blister_packaging_orders,
        routeNames.pharmacy_blister_packaging_invoices,
        routeNames.pharmacy_blister_packaging_packmed_files,
        routeNames.pharmacy_packaging_processing,
        routeNames.pharmacy_packaging_orders,
        routeNames.pharmacy_packaging_all_d_logs,
		routeNames.pharmacy_packaging_din_management,
        routeNames.pharmacy_packaging_invoices,
        routeNames.pharmacy_packaging_prn_processing,
        routeNames.pharmacy_packaging_liquid_processing,
        routeNames.pharmacy_packaging_order_preview,

        routeNames.pharmacy_archived_deliveries,
        routeNames.pharmacy_driver,
        routeNames.pharmacy_delivery_lables,
        routeNames.pharmacy_expiring_rx,
        routeNames.pharmacy_expiring_rx_v2,
        routeNames.pharmacy_patient_counselling,
        routeNames.pharmacy_consent_form_logs,
        routeNames.pharmacy_memo,
        routeNames.pharmacy_drugs_billing,
        routeNames.pharmacy_oat_prescriptions,
        routeNames.pharmacy_ongoing_prescritiptions,
        routeNames.pharmacy_returned_patches,
        routeNames.pharmacy_fentanyl_patch_log,
        routeNames.pharmacy_reversed_deliveries,
        routeNames.pharmacy_tranfer_patient_concent,
        routeNames.pharmacy_accountability,
        routeNames.pharmacy_dwi,
        routeNames.pharmacy_investigate_rx,
        routeNames.pharmacy_rxnumber_date_sync,
        routeNames.pharmacy_rx_signature_request_list,
        routeNames.pharmacy_patient_soap_notes,
        routeNames.pharmacy_med_review_logs,
        routeNames.pharmacy_create_soap_notes,
        routeNames.pharmacy_soap_notes_logs,
        routeNames.pharmacy_med_review_logs_v2,
        routeNames.PHARMACY_PATIENT_PROFILE,
        routeNames.pharmacy_sms_tabs,
        routeNames.pharmacy_accountability_prep_for_new_rx,
        routeNames.pharmacy_accountability_after_process_prep_check,
        routeNames.pharmacy_mark_flexi,
        routeNames.pharmacy_blister_packaging_monthly_invoice,
        routeNames.pharmacy_packaging_monthly_invoice,
        routeNames.pharmacy_packaging_analytics,
        routeNames.pharmacy_admin_payroll,
        routeNames.pharmacy_accounts,
        routeNames.pharmacy_super_nova_verification,
        routeNames.pharmacy_half_baked,
        routeNames.pharmacy_erx,
        routeNames.pharmacy_pharmacare,
        routeNames.CHANGE_LOG_ROUTE,
        routeNames.pharmacy_team_avalibility,
        routeNames.pharmacy_driver_clinic_call_logs,
    ]
    const isRoute = allRoutes.includes(location.pathname)

    const accountabilityRoute = [
        routeNames.pharmacy_accountability_today_missed_rx,
        routeNames.pharmacy_archived_deliveries,
        routeNames.pharmacy_investigate_rx,
        routeNames.pharmacy_task_management,
        routeNames.pharmacy_settings,
        routeNames.pharmacy_team_avalibility,
        routeNames.pharmacy_accountability_prep_check
    ]

    const bgcolorpath = [
        routeNames.pharmacy_search_module,
    ]

    const taskManagementRoute = location.pathname.includes(routeNames.pharmacy_task_management)
    const markDeliveredRoute = location.pathname.includes(routeNames.pharmacy_rxnumber_date_sync)

    const isInvestigationRxDetailRoute = (
        location.pathname === routeNames.pharmacy_investigate_rx &&
        new URLSearchParams(location.search).has('rx-number')
    )
    const isAccountabilityRoute = accountabilityRoute.includes(location.pathname) && !isInvestigationRxDetailRoute
    const isHalfBakedRoute = location.pathname === routeNames.pharmacy_half_baked

    const isSearchModuleRoute = bgcolorpath.includes(location.pathname)
    const isERxRoute = location.pathname.includes(routeNames.pharmacy_erx)
    const forceWindowScrollRoutes = [
        routeNames.pharmacy_app_prescriptions,
        routeNames.pharmacy_order_transfer,
        routeNames.pharmacy_order_new,
        routeNames.pharmacy_app_refill_request,
        routeNames.pharmacy_app_notification_list,
        routeNames.pharmacy_app_pharmacy_services,
        routeNames.pharmacy_app_pharmacy_services_alias,
        routeNames.pharmacy_app_patient_chat,
    ]
    const shouldForceWindowScroll = forceWindowScrollRoutes.includes(location.pathname)

    useEffect(() => {
        if (!shouldForceWindowScroll) return undefined;

        const previousHtmlOverflowY = document.documentElement.style.overflowY;
        const previousBodyOverflowY = document.body.style.overflowY;

        document.documentElement.style.overflowY = 'scroll';
        document.body.style.overflowY = 'scroll';

        return () => {
            document.documentElement.style.overflowY = previousHtmlOverflowY;
            document.body.style.overflowY = previousBodyOverflowY;
        };
    }, [shouldForceWindowScroll])

    return (
        <div className={`BodyBgColor ${shouldForceWindowScroll ? 'min-h-[calc(100vh+1px)]' : ''}`}>
            {/* <div className={` mx-auto pb-5 ${!isRoute ? 'container-fluid xl:px-20 px-5 pt-5' : 'container-fluid pt-2  px-4'}`}> */}
            <div className={`${!isRoute ? 'container-fluid mx-auto px-4 pt-5 pb-5' : 'container-fluid pt-2  px-4'}`}>
                <div className="grid grid-cols-12 gap-4">
                    {!isRoute && <Sidebar />}
                    <div className={`${!isRoute ? 'lg:col-span-9' : 'lg:col-span-12'} col-span-12 `}>
                        <BreadCrumb activeTab={activeTab} />
                        {/* <div className={`${!isRoute ? 'lg:container container-fluid' : 'container-fluid'} mt-2`}> */}
                        <div className={`${!isRoute ? '' : 'container-fluid'} mt-2`}>
                            <div className={` ${(isAccountabilityRoute || isHalfBakedRoute || isSearchModuleRoute) ? 'p-0' :
                                isERxRoute ? 'p-2' :
                                    'md:py-5 md:px-5 sm:py-5 sm:px-5 lg:py-5 lg:px-5 p-4'} ${isSearchModuleRoute ? 'bg-transparent border-none' : 'bg-white border rounded-lg '} ${(taskManagementRoute || markDeliveredRoute) ? 'min-h-[calc(100vh-200px)]' : ''}`}>
                                {children}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
